
export const data = {
      info: {
            name: "xatMe",
            id_xat: "0000",
            status: 'Set your status',
            location: "xat.com",
            avatar: "https://i.postimg.cc/zX6Q3yZj/no-user.jpg",
            about: "Write a little bit about yourself",
            me: "https://xat.com/editme",
            homepage: "https://xatme.com",
            forum: "https://forum.xat.com"
      },
      relation: {
            name: "Set relationship name",
            id_xat: "Set relationship id xat",
            avatar: "https://i.postimg.cc/zX6Q3yZj/no-user.jpg",
            about: "Write a little bit about relationship",
            me: "https://xat.com/editme",
            love_count: "Set your romance time"
      },
      banner: {
            image: "https://i.postimg.cc/08xg0Jgv/banner-bg.jpg",
            title: "Please define a title and choose an image to use as a banner"
      },
      social: {
            facebook: "https://www.facebook.com",
            twitter: "https://www.facebook.com",
            instagram: "https://www.facebook.com",
            youtube: "https://www.facebook.com",
            tumblr: "https://www.tumblr.com",
            tiktok: "https://www.tiktok.com",
            discord: "https://www.discord.com",
            twitch: "https://www.twitch.tv"
      },
      galleries: {
            img: "https://i.postimg.cc/Rhfxcr48/banner.jpg"
      },
      logo: {
            src: "https://xatimg.com/image/XrS4bBPweXef.png"
      }
}


export function getAvatar(name){

      return `https://api.dicebear.com/5.x/initials/svg?seed=${name}&fontSize=26`
}

export const credit = {
      name: "JasoOficial",
      status: "xat.com/centraldosplayers",
      avatar: "https://i.postimg.cc/BQ6PDw2T/user.jpg",
      about: "I am a web designer specialized in enhancing the user experience for xat.com, with a focus on players and xatspaces. I am also the creator of xatme.com, an innovative platform aimed at providing a renewed experience within xatspaces.",
      hastag: "#xatspace",
      link: "https://xatme.com"
}